<div class="ui-multiselect" [class.ui-multiselect--disabled]="disabled">
  @if (label) {
    <label class="ui-multiselect__label">{{ label }}</label>
  }

  <button
    type="button"
    class="ui-multiselect__trigger"
    [disabled]="disabled"
    [attr.aria-expanded]="open()"
    (click)="toggleDropdown()"
  >
    <span class="ui-multiselect__summary" [class.ui-multiselect__summary--empty]="!summary">
      {{ summary || placeholder }}
    </span>
    <span class="ui-multiselect__chevron">
      <ui-icon [name]="open() ? 'chevron-up' : 'chevron-down'" size="sm" />
    </span>
  </button>

  @if (open()) {
    <div class="ui-multiselect__dropdown">
      @for (option of options; track option.value) {
        <label class="ui-multiselect__option">
          <input
            type="checkbox"
            [checked]="isChecked(option.value)"
            (change)="toggleOption(option)"
          />
          <span>{{ option.label }}</span>
        </label>
      } @empty {
        <div class="ui-multiselect__empty">Aucune option</div>
      }
    </div>
  }

  @if (hint) {
    <p class="ui-multiselect__hint">{{ hint }}</p>
  }
  @if (error) {
    <p class="ui-multiselect__error">{{ error }}</p>
  }
</div>
